module.exports = __webpack_public_path__ + "img/ic_unfinished_order.92d8f78d.png";